import React from "react";
import LoginView from "../views/Login";
import { withEmail } from "./withEmail";
import { withAppContext } from "./withAppContext";

/**
 * helper HOC to prevent unauthorized access to
 * @param {Function} WrappedComponent
 * @return {Function}
 */
export const withAuthentication = (WrappedComponent) => {
    return withAppContext(
        withEmail(props => {
            if (!props.email) {
                return <LoginView
                    history={props.history}
                    match={props.match}
                />
            }
            return <WrappedComponent {...props}/>;
        })
    );
};
